/* These Bricks — košarica: prevodi Discounty, brezplačna dostava, zaupanje */
(function () {
  var FREE_SHIP = 6000; // v centih
  var LABELS = { 'Total': 'Redna cena', 'Saving': 'Prihraniš', 'Subtotal': 'Vmesni seštevek' };

  function translate(root) {
    (root || document).querySelectorAll('.discounty-cart-widget__total-label, .discounty-cart-widget__saving-label, [class^="discounty"] span').forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent.trim();
      if (LABELS[t]) el.textContent = LABELS[t];
    });
  }

  function money(cents) {
    var p = (Math.abs(cents) / 100).toFixed(2).split('.');
    return (cents < 0 ? '-' : '') + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1] + '€';
  }

  var isCart = !!document.querySelector('main[data-template^="cart"]');

  function renderShip(total) {
    if (!isCart) return;
    var summary = document.querySelector('main[data-template^="cart"] .cart-summary__inner');
    if (!summary) return;
    var box = summary.querySelector('.tb-cart-ship');
    if (!box) {
      box = document.createElement('div');
      box.className = 'tb-cart-ship';
      summary.insertBefore(box, summary.firstChild);
    }
    var pct = Math.min(100, Math.round(total / FREE_SHIP * 100));
    var cls, html;
    if (total >= FREE_SHIP) {
      cls = 'tb-cart-ship tb-cart-ship--ok';
      html = '🎉 <strong>Brezplačna dostava</strong> je vključena v tvoje naročilo.<div class="tb-cart-ship__bar"><div class="tb-cart-ship__fill" style="width:100%"></div></div>';
    } else {
      cls = 'tb-cart-ship';
      html = 'Do <strong>brezplačne dostave</strong> ti manjka še <strong>' + money(FREE_SHIP - total) + '</strong>.<div class="tb-cart-ship__bar"><div class="tb-cart-ship__fill" style="width:' + pct + '%"></div></div>';
    }
    if (box.getAttribute('data-total') !== String(total)) {
      box.setAttribute('data-total', String(total));
      box.className = cls;
      box.innerHTML = html;
    }
  }

  function renderTrust() {
    if (!isCart) return;
    var ctas = document.querySelector('main[data-template^="cart"] .cart__ctas');
    if (!ctas || ctas.parentNode.querySelector('.tb-cart-trust')) return;
    var ul = document.createElement('ul');
    ul.className = 'tb-cart-trust';
    ul.innerHTML =
      '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg><span><strong>Pošljemo v 1–3 delovnih dneh</strong> z GLS, možno tudi po povzetju</span></li>' +
      '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg><span><strong>14 dni</strong> za vračilo</span></li>' +
      '<li class="tb-cart-trust__pay"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg><span><strong>Varno plačilo</strong></span></li>' +
      '<li class="tb-pays"></li>';
    var tpl = document.getElementById('tb-pay-icons');
    var pays = ul.querySelector('.tb-pays');
    if (tpl && tpl.content && tpl.content.childElementCount) pays.appendChild(tpl.content.cloneNode(true));
    else pays.remove();
    ctas.parentNode.insertBefore(ul, ctas.nextSibling);
  }

  function hideSoldOutRecs() {
    if (!isCart) return;
    document.querySelectorAll('main[data-template^="cart"] .resource-list').forEach(function (list) {
      var shown = 0;
      list.querySelectorAll(':scope > .resource-list__item').forEach(function (item) {
        var soldOut = Array.prototype.some.call(item.querySelectorAll('.product-badges__badge'), function (b) {
          return /razprodano/i.test(b.textContent);
        });
        if (soldOut || shown >= 4) { item.style.display = 'none'; } else { shown++; }
      });
    });
  }


  var productCache = {};
  function getCompareAt(item) {
    var h = item.handle;
    var p = productCache[h] || (productCache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; }));
    return p.then(function (prod) {
      if (!prod) return 0;
      for (var i = 0; i < prod.variants.length; i++) {
        if (prod.variants[i].id === item.variant_id) return prod.variants[i].compare_at_price || 0;
      }
      return 0;
    });
  }

  function row(label, value, cls) {
    return '<div class="tb-bd__row' + (cls ? ' ' + cls : '') + '"><span>' + label + '</span><span>' + value + '</span></div>';
  }

  function renderBreakdown(cart) {
    if (!isCart) return;
    var totals = document.querySelector('main[data-template^="cart"] .cart-totals');
    var anchor = totals && totals.querySelector('.cart-totals__container');
    if (!anchor) return;
    Promise.all(cart.items.map(getCompareAt)).then(function (cmp) {
      var count = 0, regular = 0, current = 0;
      cart.items.forEach(function (it, i) {
        count += it.quantity;
        current += it.original_line_price;
        regular += Math.max(cmp[i], it.original_price) * it.quantity;
      });
      var sale = Math.max(0, regular - current);
      var code = cart.total_discount || 0;
      var codeNames = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; }).join(', ');
      var save = sale + code;
      var free = cart.total_price >= FREE_SHIP;

      var html = '';
      if (sale > 0) {
        html += row('Redna cena (' + count + (count === 1 ? ' izdelek' : count === 2 ? ' izdelka' : count < 5 ? ' izdelki' : ' izdelkov') + ')', '<s>' + money(regular) + '</s>');
        html += row('Akcijski popust', '−' + money(sale), 'tb-bd__row--save');
      } else {
        html += row('Izdelki (' + count + ')', money(current));
      }
      if (code > 0) html += row('Popust' + (codeNames ? ' <em>' + codeNames + '</em>' : ''), '−' + money(code), 'tb-bd__row--save');
      html += row('Dostava', free ? '<b class="tb-bd__free">Brezplačna</b>' : 'izračun ob zaključku');
      if (save > 0) html += '<div class="tb-bd__saved">Skupaj prihraniš <strong>' + money(save) + '</strong></div>';

      var key = cart.total_price + '|' + regular + '|' + code + '|' + count;
      var box = totals.querySelector('.tb-cart-breakdown');
      if (!box) {
        box = document.createElement('div');
        box.className = 'tb-cart-breakdown';
        anchor.parentNode.insertBefore(box, anchor);
      }
      if (box.getAttribute('data-key') !== key) {
        box.setAttribute('data-key', key);
        box.innerHTML = html;
      }
      var note = totals.querySelector('.cart-totals__tax-note');
      var noteTxt = free ? 'Cena vključuje DDV. Dostava je brezplačna.' : 'Cena vključuje DDV. Dostava se obračuna ob zaključku nakupa.';
      if (note && note.textContent.trim() !== noteTxt) note.textContent = noteTxt;
      var lbl = totals.querySelector('.cart-totals__total-label');
      if (lbl && lbl.textContent.trim() !== 'Skupaj za plačilo') lbl.textContent = 'Skupaj za plačilo';
    });
  }



  /* ---------- Ponudbe pod izdelki: vitrina (glede na set) + košarice ---------- */
  var OFFERS = {
    vitrina: { handle: 'displaybox-thesebricks', variant: 53944706793799 },
    kosarica: { handle: 'kosarica', variant: 54649586057543 }
  };
  var prodJs = {};
  function getProd(handle) {
    return prodJs[handle] || (prodJs[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }));
  }
  var metaCache = {};
  function hasVitrina(handle) {
    return metaCache[handle] || (metaCache[handle] = fetch('/products/' + handle + '?view=tbmeta')
      .then(function (r) { return r.text(); })
      .then(function (t) { try { return JSON.parse(t.trim()).vitrina === true; } catch (e) { return false; } })
      .catch(function () { return false; }));
  }
  function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function offerCard(key, p, v, tag, desc, fit) {
    var img = (p.featured_image || '').replace(/^\/\//, 'https://');
    var el = document.createElement('div');
    el.className = 'tb-cart-upsell tb-cart-upsell--' + key;
    el.setAttribute('data-offer', key);
    el.innerHTML =
      '<a class="tb-cu__img" href="' + p.url + '"><img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="' + esc(p.title) + '" loading="lazy"></a>' +
      '<div class="tb-cu__body">' +
        '<div class="tb-cu__tag">' + tag + '</div>' +
        '<a class="tb-cu__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
        (fit ? '<div class="tb-cu__fit">✓ ' + fit + '</div>' : '') +
        '<p class="tb-cu__desc">' + desc + '</p>' +
        '<div class="tb-cu__foot">' +
          '<span class="tb-cu__price">' + money(v.price) + '</span>' +
          '<button type="button" class="tb-cu__add">+ Dodaj v košarico</button>' +
        '</div>' +
      '</div>';
    el.querySelector('.tb-cu__add').addEventListener('click', function () {
      var btn = this;
      btn.disabled = true;
      btn.textContent = 'Dodajam…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.reload();
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = '+ Dodaj v košarico';
      });
    });
    return el;
  }

  var offersBusy = false;
  function renderOffers(cart) {
    if (!isCart || offersBusy) return;
    var host = document.querySelector('main[data-template^="cart"] .cart-page__items');
    if (!host) return;
    var ids = cart.items.map(function (it) { return it.variant_id; });
    var sets = cart.items.filter(function (it) { return it.handle !== OFFERS.vitrina.handle && it.handle !== OFFERS.kosarica.handle; });
    var key = ids.join(',');
    var wrap = host.querySelector('.tb-offers');
    if (wrap && wrap.getAttribute('data-key') === key) return;
    if (!sets.length) { if (wrap) wrap.remove(); return; }
    offersBusy = true;

    var wantKos = ids.indexOf(OFFERS.kosarica.variant) === -1;
    var wantVit = ids.indexOf(OFFERS.vitrina.variant) === -1;

    var vitPromise = !wantVit ? Promise.resolve(null) :
      Promise.all(sets.map(function (it) { return hasVitrina(it.handle); })).then(function (flags) {
        for (var i = 0; i < flags.length; i++) if (flags[i]) return sets[i];
        return null;
      });

    Promise.all([
      vitPromise,
      wantVit ? getProd(OFFERS.vitrina.handle).catch(function () { return null; }) : null,
      wantKos ? getProd(OFFERS.kosarica.handle).catch(function () { return null; }) : null
    ]).then(function (res) {
      var vitSet = res[0], vitP = res[1], kosP = res[2];
      var box = document.createElement('div');
      box.className = 'tb-offers';
      box.setAttribute('data-key', key);
      function pick(p, id) { if (!p) return null; for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id && p.variants[i].available) return p.variants[i]; return null; }
      var vv = pick(vitP, OFFERS.vitrina.variant);
      if (vitSet && vv) {
        box.appendChild(offerCard('vitrina', vitP, vv, 'Zaščiti svoj set pred prahom',
          'Premium akrilna vitrina spremeni tvoj sestavljen set v razstavni eksponat — brez prahu in radovednih prstov.',
          'Kompatibilno s setom ' + esc(vitSet.product_title)));
      }
      var kv = pick(kosP, OFFERS.kosarica.variant);
      if (kv) {
        box.appendChild(offerCard('kosarica', kosP, kv, 'Popoln dodatek k tvojemu setu',
          'Komplet 7 košaric v treh velikostih — med sestavljanjem sproti razvrstiš kocke, jih ne izgubiš in hitreje najdeš pravo.'));
      }
      var old = host.querySelector('.tb-offers');
      if (old) old.remove();
      if (box.children.length) host.appendChild(box);
    }).catch(function () {}).then(function () { offersBusy = false; });
  }

  /* ---------- Prazna košarica ---------- */
  function renderEmpty() {
    if (!isCart) return;
    var page = document.querySelector('main[data-template^="cart"] .cart-page--empty');
    if (!page || page.querySelector('.tb-empty') || page.parentNode.querySelector('.tb-empty__icon')) return;
    var title = page.querySelector('.cart-page__title');
    var el = document.createElement('div');
    el.className = 'tb-empty';
    el.innerHTML =
      '<div class="tb-empty__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg></div>' +
      '<p class="tb-empty__sub">Izberi svoj naslednji set — ob nakupu nad 60€ je dostava brezplačna.</p>' +
      '<div class="tb-empty__cats">' +
        '<a href="/collections/avtomobili">Avtomobili</a>' +
        '<a href="/collections/motorji">Motorji</a>' +
        '<a href="/collections/delovni-stroji-tovornjaki">Delovni stroji</a>' +
        '<a href="/collections/vesolje-roboti">Vesolje & roboti</a>' +
        '<a href="/collections/novosti">Novosti</a>' +
      '</div>';
    if (title) {
      title.parentNode.insertBefore(el, title.nextSibling);
      var icon = el.querySelector('.tb-empty__icon');
      title.parentNode.insertBefore(icon, title);
    }
    var h = document.querySelector('main[data-template^="cart"] .resource-list') && document.querySelectorAll('main[data-template^="cart"] h3');
    if (h) Array.prototype.forEach.call(h, function (x) { if (/Morda vam bo/i.test(x.textContent)) x.textContent = 'Najbolj priljubljeni seti'; });
  }

  function openDiscount() {
    if (!isCart) return;
    var d = document.querySelector('main[data-template^="cart"] .cart-discount details');
    if (!d) return;
    if (!d.open) d.open = true;
    var sum = d.querySelector('summary');
    if (sum && !sum.getAttribute('data-tb')) {
      sum.setAttribute('data-tb', '1');
      sum.addEventListener('click', function (e) { e.preventDefault(); }, true);
      sum.setAttribute('tabindex', '-1');
      var lab = sum.querySelector('.cart-discount__label');
      if (lab) lab.textContent = 'Imaš kodo za popust?';
    }
    var inp = d.querySelector('.cart-discount__input');
    if (inp && inp.getAttribute('placeholder') !== 'Vpiši kodo') inp.setAttribute('placeholder', 'Vpiši kodo');
    var btn = d.querySelector('.cart-discount__button');
    if (btn && btn.textContent.trim() !== 'Uporabi') btn.textContent = 'Uporabi';
  }


  /* ---------- Potrditev "Dodano v košarico" (namesto predala) ---------- */
  var atcEl = null;
  function atcBuild() {
    if (atcEl) return atcEl;
    atcEl = document.createElement('div');
    atcEl.className = 'tb-atc';
    atcEl.setAttribute('aria-hidden', 'true');
    atcEl.innerHTML =
      '<div class="tb-atc__overlay"></div>' +
      '<aside class="tb-atc__panel" role="dialog" aria-modal="true" aria-label="Dodano v košarico">' +
        '<button type="button" class="tb-atc__close" aria-label="Zapri">&times;</button>' +
        '<div class="tb-atc__head"><span class="tb-atc__check">✓</span> Dodano v košarico</div>' +
        '<div class="tb-atc__item"></div>' +
        '<div class="tb-atc__ship"></div>' +
        '<div class="tb-atc__sum"></div>' +
        '<a class="tb-atc__go" href="/cart">Na košarico in zaključek nakupa</a>' +
        '<button type="button" class="tb-atc__cont">Nadaljuj nakup</button>' +
        '<div class="tb-atc__note">Pošljemo v 1–3 delovnih dneh · 14 dni za vračilo</div>' +
      '</aside>';
    document.body.appendChild(atcEl);
    function close() { atcEl.classList.remove('is-open'); atcEl.setAttribute('aria-hidden', 'true'); }
    atcEl.querySelector('.tb-atc__overlay').addEventListener('click', close);
    atcEl.querySelector('.tb-atc__close').addEventListener('click', close);
    atcEl.querySelector('.tb-atc__cont').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return atcEl;
  }

  function atcShow(variantId) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items.length) return;
      var it = cart.items.filter(function (x) { return String(x.variant_id) === String(variantId); })[0] || cart.items[0];
      var el = atcBuild();
      var img = (it.image || '').replace(/^\/\//, 'https://');
      el.querySelector('.tb-atc__item').innerHTML =
        (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="">' : '') +
        '<div><div class="tb-atc__t">' + esc(it.product_title) + '</div><div class="tb-atc__p">' + money(it.final_price) + '</div></div>';
      var total = cart.total_price, pct = Math.min(100, Math.round(total / FREE_SHIP * 100));
      el.querySelector('.tb-atc__ship').className = 'tb-atc__ship tb-cart-ship' + (total >= FREE_SHIP ? ' tb-cart-ship--ok' : '');
      el.querySelector('.tb-atc__ship').innerHTML = (total >= FREE_SHIP
        ? '🎉 <strong>Brezplačna dostava</strong> je vključena.'
        : 'Do <strong>brezplačne dostave</strong> ti manjka še <strong>' + money(FREE_SHIP - total) + '</strong>.') +
        '<div class="tb-cart-ship__bar"><div class="tb-cart-ship__fill" style="width:' + pct + '%"></div></div>';
      var n = cart.item_count;
      el.querySelector('.tb-atc__sum').innerHTML = 'V košarici: ' + n + (n === 1 ? ' izdelek' : n === 2 ? ' izdelka' : n < 5 ? ' izdelki' : ' izdelkov') + ' · <strong>' + money(total) + '</strong>';
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
    }).catch(function () {});
  }

  function modalOpen() { return !!document.querySelector('.tb-kos-overlay.is-open, .tb-vit-overlay.is-open'); }
  function atcAfterAdd(variantId) {
    if (isCart) return;
    var tries = 0;
    (function wait() {
      tries++;
      if (modalOpen()) { setTimeout(wait, 300); return; }      // počakaj, da stranka zapre ponudbo
      if (tries < 5) { setTimeout(wait, 300); return; }          // dovolj časa, da se ponudba odpre
      atcShow(variantId);
    })();
  }

  function variantFromBody(body) {
    try {
      if (!body) return null;
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.get('id');
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') { var j = JSON.parse(body); return j.id || (j.items && j.items[0] && j.items[0].id); }
        var m = body.match(/(?:^|&)id=(\d+)/); return m ? m[1] : null;
      }
    } catch (e) {}
    return null;
  }

  if (!isCart && window.fetch) {
    var _f = window.fetch;
    window.fetch = function (input, init) {
      var url = (input && input.url) ? input.url : input;
      var isAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
      var fromOffer = !!document.querySelector('.tb-kos-add:disabled, .tb-vit-add:disabled');
      var vid = isAdd ? variantFromBody(init && init.body) : null;
      return _f.apply(this, arguments).then(function (res) {
        if (isAdd && !fromOffer && res.ok) atcAfterAdd(vid);
        return res;
      });
    };
  }

  function refresh() {
    translate();
    renderTrust();
    openDiscount();
    renderEmpty();
    if (isCart) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { renderShip(c.total_price); renderBreakdown(c); renderOffers(c); })
        .catch(function () {});
    }
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 150); }

  function init() {
    refresh();
    hideSoldOutRecs();
    document.addEventListener('cart:update', schedule);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 1 && t.closest && t.closest('.tb-cart-ship, .tb-cart-trust, .tb-cart-breakdown, .tb-offers, .tb-empty, .tb-atc')) continue;
        if (t.nodeType === 3 && t.parentElement && t.parentElement.closest('.tb-cart-ship, .tb-cart-trust, .tb-cart-breakdown, .tb-offers, .tb-empty, .tb-atc')) continue;
        if (t.nodeType === 1 && (t.closest && (t.closest('.discounty-portal, .cart-summary__inner, cart-drawer-component, .cart-drawer') ))) { schedule(); return; }
        if (muts[i].addedNodes.length) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            var n = muts[i].addedNodes[j];
            if (n.nodeType === 1 && ((n.matches && n.matches('.discounty-portal, [class*="discounty"]')) || (n.querySelector && n.querySelector('[class*="discounty"]')))) { schedule(); return; }
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
